export enum ProfilerEventDomain {
  ANALYSES = 'analyses',
  GRAPHQL = 'graphQL',
  INVENTORY = 'inventory',
  LAB_AUTOMATION = 'lab automation',
  MOLBIO = 'molbio',
  NAVIGATION = 'navigation',
  NOTEBOOK = 'notebook',
  REGISTRY = 'registry',
  REQUESTS_V2 = 'requests v2',
  RESULTS = 'results',
  SEARCH = 'search',
  PROCEDURES = 'procedures',
  PROCESSES = 'processes',
  WORKSHEETS = 'worksheets',
  STUDIES = 'studies',
  REVIEWS = 'reviews',
  SAMPLE_TESTS = 'sample tests',
}

export interface ProfilerEvent {
  domain: ProfilerEventDomain;
  feature: string;
  action: string;
  id?: string;
}

export interface ProfilerEventValue {
  timestamp: number;
  extra?: Record<string, unknown>;
  id?: string;
}

export type EventTags = Record<string, string | number | boolean>;

/**
 * Generic interface for an event's metadata, to be used with processTimingEvent
 */
export interface EventMetadata extends Record<string, unknown> {
  // Metadata for the distribution event - charged by cardinality of tags, so keep it small
  distributionMetadata: EventTags;
  // Metadata for the action event, can put more information here that won't be used for SLOs
  actionMetadata: EventTags;
}

// Useful for event metadata when a value is not specified
// Using a sentinel value instead of null or an empty string will make DataDog searches easier
export const NOT_SPECIFIED = 'not_specified';
